export const getForRowVariableName = (name?: string): string => {
  if (!name) {
    return 'row';
  }

  return 'row_' + name.replace('for_start_', '');
}

export const getForStartName = (forEndName: string) => {
  return forEndName.replace('for_end_', 'for_start_');
}
